import { buildGlobalAction, buildInlineComputedView } from "./../../builder.js";
class ClickhouseSegmentmembershipsNamespace {
  constructor(clientOrParent) {
    this.clientOrParent = clientOrParent;
    /** Executes the insertSegmentMemberships global action. */
    this.insertSegmentMemberships = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "insertSegmentMemberships",
      operationName: "insertSegmentMemberships",
      operationReturnType: "ClickhouseSegmentMembershipsInsertSegmentMemberships",
      namespace: ["clickhouse", "segmentMemberships"],
      variables: {
        segmentMemberships: { required: false, type: "String" },
        source: { required: false, type: "String" },
        retry: { required: false, type: "Boolean" }
      }
    });
    /** Executes an inline computed view. */
    this.view = buildInlineComputedView(this, {
      type: "computedView",
      operationName: "gellyView",
      functionName: "view",
      gqlFieldName: "gellyView",
      namespace: ["clickhouse", "segmentMemberships"],
      variables: {
        query: { type: "String", required: true },
        args: { type: "JSONObject" }
      }
    });
    this.connection = this.clientOrParent.connection;
  }
}
export {
  ClickhouseSegmentmembershipsNamespace
};
//# sourceMappingURL=segmentMemberships.js.map
